module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-02-a6b738fe080d67e1264c084303583756.jpg";